'use client'

import dynamic from 'next/dynamic'
import { usePathname } from 'next/navigation'
import { useEffect, useState } from 'react'

import { URLS } from '@/configs/urls'
import { scheduleNonCriticalWork } from '@/lib/perf/scheduleNonCriticalWork'

const CookieConsent = dynamic(() => import('@/ui/CookieConsent'), {
  ssr: false
})

// /join is the paid-traffic landing: every second before consent is a visitor
// who may leave uncounted, so the banner skips the idle wait and shows sooner.
const AD_LANDING_REVEAL_DELAY_MS = 1000

export default function CookieConsentLazy() {
  const isAdLanding = usePathname() === URLS.JOIN
  const [shouldLoad, setShouldLoad] = useState(false)

  // Reveal on the first user intent OR after an idle deadline. We deliberately
  // do NOT use schedulePathAwareNonCriticalWork here: on the home path that
  // helper waits for user intent with no deadline, so a visitor who lands and
  // reads without scrolling never sees the consent banner — and therefore can
  // never grant consent, so analytics never loads for that visit. The banner
  // must be able to appear on its own. scheduleNonCriticalWork keeps the same
  // intent listeners but also gives up waiting after the idle timeout. The
  // banner previously carried a `pathname === URLS.JOIN` exclusion that stopped
  // it (and thus all tracking) from ever loading on the /join ad landing; that
  // exclusion is removed so paid traffic can consent and be measured.
  useEffect(() => {
    return scheduleNonCriticalWork(() => {
      setShouldLoad(true)
    })
  }, [])

  if (isAdLanding) {
    return <CookieConsent revealDelayMs={AD_LANDING_REVEAL_DELAY_MS} />
  }

  if (!shouldLoad) {
    return null
  }

  return <CookieConsent />
}
